import { FC } from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

import { StoreButtonBaseProps } from "./StoreButtonBase.types";
import StyledStoreButtonBase from "./styling/StoreButtonBase.styling";

const StoreButtonBase: FC<StoreButtonBaseProps> = ({
	className,
	children,
	...props
}) => {
	const block = new BemIt("StoreButtonBase");

	return (
		<StyledStoreButtonBase
			className={addClass(className).after(block)}
			{...props}
		>
			{children}
		</StyledStoreButtonBase>
	);
};

export default StoreButtonBase;
